import { AddressFormData } from 'src/app/_widgets/address-form/address-form-data';
import { BeChannel } from './be-channel';
import { Channel } from './channel';

export class ChannelFactory {
  static toView(data: BeChannel) {
    let channel: Channel = {
      certificato: data.certificato,
      crifPwd: data.crifPwd,
      crifUser: data.crifUser,
      dataInizioAttivita: data.dataInizioAttivita,
      dataIscrizione: data.dataIscrizione,
      email: data.email,
      formaGiuridica: data.formaGiuridica,
      id: data.id,
      nome: data.nome,
      pec: data.pec,
      piva: data.piva,
      platfond: data.platfond,
      rae: data.rae,
      rea: data.rea,
      settore: data.settore,
      status: data.status,
      telefono1: data.telefono1,
      telefono2: data.telefono2,
      timestampIns: data.timestampIns,
      timestampMod: data.timestampMod,
      type: data.type,
      numeroIscrizioneOAM: data.numeroIscrizioneOAM || '',
      partecipante: data.partecipante,
      identificativoTUB: data.identificativoTUB,
      identificativoCreditore: data.identificativoCreditore,
      iban: data.iban,
      intestatarioIban: data.intestatarioIban,
      location: {
        street_number: data.civicoLoco,
        route: data.indirizzoLoco,
        postal_code: data.capLoco,
        country: data.statoLoco,
        administrative_area_level_2: data.provinciaLoco,
        administrative_area_level_3: data.comuneLoco,
      },
      numeroStipule: data.numeroStipule,
      prodotti: data.prodotti,
    };
    return channel;
  }

  static toDomain(
    channel: Partial<Channel>,
    address: Partial<AddressFormData>
  ) {
    let domainChannel: Partial<BeChannel> = {
      certificato: channel.certificato,
      crifPwd: channel.crifPwd,
      crifUser: channel.crifUser,
      dataInizioAttivita: channel.dataInizioAttivita,
      dataIscrizione: channel.dataIscrizione,
      email: channel.email,
      formaGiuridica: channel.formaGiuridica,
      id: channel.id,
      nome: channel.nome,
      numeroIscrizioneOAM: channel.numeroIscrizioneOAM,
      pec: channel.pec,
      piva: channel.piva,
      platfond: channel.platfond,
      rae: channel.rae,
      rea: channel.rea,
      settore: channel.settore,
      status: channel.status,
      telefono1: channel.telefono1,
      telefono2: channel.telefono2,
      timestampIns: channel.timestampIns,
      timestampMod: channel.timestampMod,
      type: channel.type,
      partecipante: channel.partecipante,
      civicoLoco: address.street_number,
      indirizzoLoco: address.route,
      capLoco: address.postal_code,
      comuneLoco: address.administrative_area_level_3,
      statoLoco: address.country,
      provinciaLoco: address.administrative_area_level_2,
      identificativoTUB: channel.identificativoTUB,
      identificativoCreditore: channel.identificativoCreditore,
      iban: channel.iban,
      intestatarioIban: channel.intestatarioIban,
      prodotti: channel.prodotti,
    };
    return domainChannel;
  }
}
